import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setVisibleMonths } from '../Redux/store';
import { setCalendarDataSelfProcessed } from '../Redux/calendarDataSelfSlice';
import { yearMonthString } from '../data/functions';
import useCalendarDataSelf from '../hooks/useCalendarDataSelf';
import { processCalendarData, addPredictions } from '../data/cycle-predictions/processCalendarData';

function CalendarLoader() {
  const dispatch = useDispatch();
  const currentUserId = useSelector((s) => s.user.profile?.id);
  const calendarData = useSelector((s) => s.calendarDataSelf.data);

  useEffect(() => {
    if (!currentUserId) return;

    // Set initial month range (3 months before today, 3 after = 7 total)
    const now = new Date();
    const prev = new Date(now.getFullYear(), now.getMonth() - 3, 1);
    const next = new Date(now.getFullYear(), now.getMonth() + 3, 1);
    const start = yearMonthString(prev);
    const end = yearMonthString(next);
    dispatch(setVisibleMonths({ startMonth: start, endMonth: end }));
  }, [currentUserId, dispatch]);

  // Use the hook to load own calendar data
  // This will handle localStorage caching and Supabase fetching with three-tier cache
  useCalendarDataSelf();

  // Process calendar data when it changes and save to Redux
  useEffect(() => {
    if (Object.keys(calendarData).length > 0) {
      const processed = processCalendarData(calendarData);
      const withPredictions = addPredictions(processed);
      dispatch(setCalendarDataSelfProcessed(withPredictions));
    }
  }, [calendarData, dispatch]);

  return null;
}

export default CalendarLoader;
